module.exports = __webpack_public_path__ + "static/media/photo-dump-team.565a909d.webp";